import { generateVegaNumberFormatExpression } from 'utils/number-formats';
import { generateVegaDateTimeFormatExpression } from 'utils/date-time-formats';

export function generateVegaLabelTextExpression(
  encoding,
  customisations,
  options = {}
) {
  if (customisations && encoding && !encoding.isBinning) {
    if (customisations.numberFormatting) {
      return generateVegaNumberFormatExpression(
        customisations,
        options.withDecimals !== false,
        options.withSpacePadding === true,
        options.field
      );
    }

    if (customisations.dateTimeFormatting) {
      return generateVegaDateTimeFormatExpression(
        customisations,
        options.withSpacePadding === true,
        options.field
      );
    }
  }
  return `datum["${options.field || 'value'}"]`;
}
